<template>
  <el-dialog title="退款" :visible.sync="visible" :append-to-body="true" width="40%">
    <div class="attention-title">注：支持部分退款</div>
    <el-form
      ref="orderRefund"
      :model="form"
      size="small"
      label-width="100px"
      :rules="refundFormRules"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="可退金额:">
            <span class="label-color">{{ form.orderRefundAmountCan }} 元</span>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="退款金额:" prop="orderRefundAmount">
            <avue-input-number
              v-model="form.orderRefundAmount"
              :precision="2"
              :placeholder="inputTitle"
              :min-rows="0"
              :max-rows="maxRows"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="扣除手续费:">
            <span class="label-color">{{ form.serviceCharge }} 元</span>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-has-permi="['ferry_only_refund']">
          <el-form-item label="退款类型:">
            <div>
              <el-radio v-model="form.ferryOrderRefundType" label="1" size="mini">
                退款退座
              </el-radio>
              <el-radio
                v-model="form.ferryOrderRefundType"
                label="2"
                size="mini"
                @change="onlyRefund"
              >
                仅退款
              </el-radio>
            </div>
            <div style="display: flex; font-size: 13px; color: #9f9f9f">
              <div>注：</div>
              <div>
                <div style="margin-bottom: -10px">退票退款，表示退款的同时退订单</div>
                <div>仅退款，表示该操作仅退款不退订单，乘客可正常乘车</div>
              </div>
            </div>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24"> -->

        <!-- </el-col> -->
        <el-col :span="24">
          <el-form-item label="退款原因:" prop="refundRemark">
            <el-input
              type="textarea"
              placeholder="说明，产生退款的实际情况，原因，退还金额的原因等等"
              v-model="form.refundRemark"
              :autosize="{ minRows: 8, maxRows: 4 }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <div class="tipsBox">
              <img style="width: 20px; height: 20px" src="./static/tips.png" />
              <span>退款须审核，审核通过后退款成功，退款后订单状态变成已退款！</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" size="small" @click="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click="hanleSubmit">确 定</el-button>
    </div>
    <el-dialog
      title="确定仅退款吗？"
      :visible.sync="onlyRefundDialogVisible"
      width="30%"
      center
      append-to-body
    >
      <span>仅退款表示本次操作仅退款不退订单，乘客依然可正常乘车！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">取 消</el-button>
        <el-button type="primary" @click="sureClick">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import { debounce } from 'lodash-es'
  import { gettkAmount, refund } from '@/api/order'
  export default {
    name: 'orderRefund',
    data() {
      return {
        onlyRefundDialogVisible: false,
        visible: false,
        maxRows: 999999,
        form: {
          orderNo: '',
          serviceCharge: 0, // 服务费
          orderRefundAmountCan: 0, // 退款金额
          ferryOrderRefundType: '1' // 退款类型
        },
        refundFormRules: {
          refundRemark: [{ required: true, message: '退款原因不能为空', trigger: 'blur' }]
        }
      }
    },
    methods: {
      init(row) {
        this.visible = true
        if (row) {
          this.form.orderNo = row.orderNo
          this.getRefundAmount(row.orderId)
        }
      },
      // 获取退款金额
      getRefundAmount(orderId) {
        gettkAmount(orderId).then((resp) => {
          this.form.serviceCharge = resp.data.serviceCharge ? resp.data.serviceCharge / 100 : 0
          this.form.orderRefundAmountCan = resp.data.orderRefundAmountCan
        })
      },

      hanleSubmit: debounce(function (event) {
        this.$refs.orderRefund.validate((valid) => {
          if (valid) {
            refund(this.form).then((resp) => {
              if (resp.code === 0) {
                this.$message.success('退款申请已提交，等待审核')
                this.form.orderRefundAmount = 0.0
                this.form.refundRemark = ''
                this.visible = false
              }
            })
          }
        })
      }, 800),
      cancel() {
        this.form.orderRefundAmount = 0.0
        this.form.refundRemark = ''
        this.visible = false
      },
      // 提示是否仅退款
      onlyRefund(e) {
        console.log(e)
        this.onlyRefundDialogVisible = true
      },
      // 确认仅退款
      sureClick() {
        this.onlyRefundDialogVisible = false
        this.form.ferryOrderRefundType = '2'
      },
      // 取消仅退款
      cancelClick() {
        this.onlyRefundDialogVisible = false
        this.form.ferryOrderRefundType = '1'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .attention-title {
    width: 120px;
    font-size: 13px;
    color: #9f9f9f;
    position: absolute;
    top: 25px;
    left: 70px;
  }
  .tipsBox {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #9f9f9f;
  }
  .tipsBox span {
    margin-left: 5px;
  }
  .label-color {
    font-weight: 800;
    color: #f56c6c;
  }
</style>
